import { Icon } from '@iconify/react'
import { Tooltip } from 'antd'
import { useState } from 'react'
import { CameraCaptureModal } from './camera-capture-modal'
import styles from './camera-capture-icon-button.module.scss'

type Props = {
  onCapture: (dataUrl: string) => void
  disabled?: boolean
  loading?: boolean
}

export const CameraCaptureIconButton = ({
  onCapture,
  disabled = false,
  loading = false,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const isDisabled = disabled || loading

  const handleClick = () => {
    if (isDisabled) return
    setIsModalOpen(true)
  }

  const handleClose = () => {
    setIsModalOpen(false)
  }

  const handleCapture = (dataUrl: string) => {
    setIsModalOpen(false)
    onCapture(dataUrl)
  }

  const tooltipTitle = loading
    ? 'Uploading photo...'
    : disabled
    ? 'Camera unavailable'
    : 'Take a photo'

  return (
    <>
      <Tooltip title={tooltipTitle}>
        <button
          type='button'
          className={styles.cameraButton}
          onClick={handleClick}
          disabled={isDisabled}>
          <Icon icon='mdi:camera-outline' width={34} height={34} />
          <span className={styles.cameraLabel}>{loading ? 'Uploading...' : 'Take photo'}</span>
        </button>
      </Tooltip>
      <CameraCaptureModal open={isModalOpen} onCapture={handleCapture} onClose={handleClose} />
    </>
  )
}
